













import { CreateElement } from "vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Location } from "vue-router";

@Component
export default class ULink extends Vue {
  // Props

  @Prop({ default: undefined })
  public to!: Location;

  @Prop({ default: null })
  public iconLeft!: string;

  @Prop({ default: null })
  public iconLeftClass!: string;

  @Prop({ default: null })
  public iconRight!: string;

  @Prop({ default: null })
  public iconRightClass!: string;

  // Computed

  public get disabled() {
    const { $attrs } = this;
    return "disabled" in $attrs && ($attrs.disabled as unknown) !== false;
  }

  public get anchor() {
    const slot = this.$scopedSlots?.default && this.$scopedSlots.default({});
    return {
      render: (h: CreateElement) =>
        h(
          "a",
          {
            class: "u-link",
            attrs: {
              disabled: this.disabled
            }
          },
          [
            this.iconLeft &&
              h("b-icon", {
                class: ["has-margin-right-25", this.iconLeftClass],
                props: {
                  icon: this.iconLeft,
                  size: "is-small"
                }
              }),
            h("u", {}, slot),
            this.iconRight &&
              h("b-icon", {
                class: ["has-margin-left-25", this.iconRightClass],
                props: {
                  icon: this.iconRight,
                  size: "is-small"
                }
              })
          ]
        )
    };
  }

  // Methods

  public onClick($e: Event, navigate?: Function) {
    // If disabled, exit and prevent default behaviour
    if (this.disabled) return $e.preventDefault();
    // Call navigate function if passed from router-link
    if (typeof navigate === "function") navigate($e);
    // Otherwise, prevent default behaviour (unless outbound)
    else if (!this.$attrs.href) $e.preventDefault();
    // Emit click event
    this.$emit("click", $e);
  }
}
